var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-10,.cls-14{mix-blend-mode:overlay;}.cls-1{fill:url(#linear-gradient);}.cls-2{fill:#eabb8c;}.cls-11,.cls-3{opacity:0.29;mix-blend-mode:multiply;fill:url(#linear-gradient-2);}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#f9d1b7;}.cls-4,.cls-9{mix-blend-mode:soft-light;}.cls-5{isolation:isolate;}.cls-6{fill:#bf9162;}.cls-7{opacity:0.36;mix-blend-mode:hard-light;fill:url(#linear-gradient-3);}.cls-8{clip-path:url(#clip-path-2);}.cls-9{fill:#eec48f;}.cls-12{clip-path:url(#clip-path-3);}.cls-13{clip-path:url(#clip-path-4);}.cls-14,.cls-15,.cls-16,.cls-19{fill:none;stroke-miterlimit:10;}.cls-14{stroke:#775b47;stroke-width:0.21912px;opacity:0.61;}.cls-15{stroke:#634738;stroke-width:3.50599px;}.cls-16,.cls-19{stroke:#f90000;}.cls-16{stroke-width:0.85004px;}.cls-17{fill:#f90000;}.cls-18{font-size:7.89215px;font-family:Calibri-Bold,\n            Calibri;font-weight:700;}.cls-19{stroke-width:0.84005px;}.cls-20{fill:#763718;}.cls-21{opacity:0.72;}.cls-22{fill:#773507;}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 31.4372,
    y1: 99.14112,
    x2: 69.93301,
    y2: 99.14112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c49a5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#b78956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad7b52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 31.4372,
    y1: 67.5928,
    x2: 170.88766,
    y2: 67.5928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9ed9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02758,
    stopColor: "#f3e598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16638,
    stopColor: "#dabf7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30465,
    stopColor: "#c6a16b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44062,
    stopColor: "#b88c5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57317,
    stopColor: "#b07f55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69832,
    stopColor: "#ad7b52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94413,
    stopColor: "#603913"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.392 54.313 170.888 80.872 69.933 80.872 31.437 54.313 132.392 54.313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 69.93301,
    y1: 112.42052,
    x2: 170.88766,
    y2: 112.42052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c49a5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15143,
    stopColor: "#ba8c57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36067,
    stopColor: "#b07f53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55866,
    stopColor: "#ad7b52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#594136"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "31.437 54.313 69.933 80.872 69.933 143.969 32.314 117.41 31.437 54.313"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "132.392 54.313 170.888 80.872 69.933 80.872 31.437 54.313 132.392 54.313"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "43.586 62.695 153.91 62.695 160.012 67.593 51.049 67.844 43.586 62.695"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 69.93301,
    y: 80.8722,
    width: 100.95464,
    height: 63.09665
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 69.93301,
    y: 80.8722,
    width: 100.95464,
    height: 63.09665
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "31.437 54.313 69.933 80.872 69.933 143.969 32.314 117.41 31.437 54.313"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "43.586 62.695 43.586 95.46 51.049 100.787 51.049 68.837 51.049 61.855 43.586 62.695"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.392 54.313 170.888 80.872 69.933 80.872 31.437 54.313 132.392 54.313"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "132.392 54.313 170.888 80.872 69.933 80.872 31.437 54.313 132.392 54.313"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "43.586 62.695 153.91 62.695 160.012 67.593 51.049 67.844 43.586 62.695"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 151.28061,
    y1: 64.53696,
    x2: 46.20597,
    y2: 64.53696
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 31.4372,
    y1: 117.41005,
    x2: 69.93301,
    y2: 143.96885
  }))), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 171.86992,
    y1: 156.54768,
    x2: 136.25718,
    y2: 156.76467
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "168.441 153.99 168.595 159.476 173.072 156.803 168.441 153.99"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 71.15089,
    y1: 156.7971,
    x2: 106.76362,
    y2: 157.01837
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "74.58 154.24 74.552 159.504 70.364 156.764 74.58 154.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 67.05089,
    y1: 148.74841,
    x2: 55.36767,
    y2: 140.5293
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "65.743 144.676 62.685 149.232 67.882 149.654 65.743 144.676"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 32.0586,
    y1: 122.83742,
    x2: 44.59823,
    y2: 131.89172
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "36.335 122.745 33.257 127.016 31.437 122.353 36.335 122.745"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(111.99955 159.08276)"
  }, "40 cm"), /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(174.0557 115.32788)"
  }, "25 cm"), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 178.83243,
    y1: 143.10363,
    x2: 178.67332,
    y2: 117.60016
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "181.39 139.755 175.905 139.905 178.832 144.163 181.39 139.755"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 178.55507,
    y1: 82.59265,
    x2: 178.55507,
    y2: 105.82004
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "181.112 86.022 175.848 85.994 178.555 81.241 181.112 86.022"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(36.20658 138.98315)"
  }, "30 cm"), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M158.30288,87.98482a6.19887,6.19887,0,1,1-6.04977,6.25152A5.94724,5.94724,0,0,1,158.30288,87.98482Zm.00639.7257a5.47831,5.47831,0,1,0,5.27151,5.42612A5.151,5.151,0,0,0,158.30927,88.71052Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 158.33957,
    y: 99.62355,
    width: 7.29084,
    height: 0.71319,
    transform: "translate(-0.87364 1.42948) rotate(-0.50426)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "165.601 100.697 167.456 99.932 165.587 99.2 165.601 100.697"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M153.44267,100.42783a6.19885,6.19885,0,1,1,6.04977-6.25147A5.94717,5.94717,0,0,1,153.44267,100.42783Zm-.00638-.7256a5.47833,5.47833,0,1,0-5.27152-5.42617A5.151,5.151,0,0,0,153.43629,99.70223Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 146.11514,
    y: 88.07596,
    width: 7.29084,
    height: 0.71318,
    transform: "translate(-0.77248 1.32145) rotate(-0.50426)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "146.145 87.715 144.29 88.481 146.158 89.213 146.145 87.715"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M95.73536,142.8271a6.051,6.051,0,1,1,5.80748-6.28516A6.05783,6.05783,0,0,1,95.73536,142.8271Zm-.45845-11.606a5.564,5.564,0,1,0,5.77929,5.34A5.5703,5.5703,0,0,0,95.27691,131.22113Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M98.50236,137.66562l.00011-.00015.039.0471.00968-.00038c.00735-.00029.00626-.02792.00528-.0415a3.09422,3.09422,0,0,0-6.04058.23031c.00382.03916.05473-.00333.05473-.00333h0a.57977.57977,0,0,1,.43681-.192.5714.5714,0,0,1,.45819.16575.06624.06624,0,0,0,.10663-.00421.64619.64619,0,0,1,.90188-.03563.06628.06628,0,0,0,.10667-.00421.64616.64616,0,0,1,.90185-.03563.06627.06627,0,0,0,.10667-.00421.64613.64613,0,0,1,.90183-.03563.06627.06627,0,0,0,.10667-.00421.64619.64619,0,0,1,.90188-.03563.06624.06624,0,0,0,.10664-.00421.5714.5714,0,0,1,.44368-.20137A.57735.57735,0,0,1,98.50236,137.66562Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M95.40417,141.163l-.00413.00017h0a.452.452,0,0,1-.46482-.4335.24353.24353,0,0,1,.40457-.1921l-.20771-5.2582a.24351.24351,0,1,1,.48664-.01922l.21466,5.434a.452.452,0,0,1-.42921.46881Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M94.81888,134.43859a.50538.50538,0,1,1-.74237-.68595,5.63841,5.63841,0,0,1,1.21636-.57172A5.638,5.638,0,0,1,94.81888,134.43859Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M97.39774,133.83713a.50538.50538,0,1,1-.74237-.68595,5.63824,5.63824,0,0,1,1.21636-.57172A5.63935,5.63935,0,0,1,97.39774,133.83713Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M98.99548,135.417a.50538.50538,0,0,1-.74237-.68595,5.6389,5.6389,0,0,1,1.21636-.57172A5.63967,5.63967,0,0,1,98.99548,135.417Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M79.57037,142.93022a6.02989,6.02989,0,1,1,5.7872-6.26322A6.03671,6.03671,0,0,1,79.57037,142.93022Zm-.45686-11.56544a5.54457,5.54457,0,1,0,5.75911,5.32138A5.55083,5.55083,0,0,0,79.11351,131.36478Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M75.7,137.53967l.53473.49412a.25247.25247,0,0,0,.18228.06716l.77444-.03059.2965-.71792a.16951.16951,0,0,1,.2093-.09642l.06887.02248a.09952.09952,0,0,0,.11375-.14973l-.578-.86909a.36616.36616,0,0,0-.34988-.16055l-.93549.11591a.09951.09951,0,0,0-.03539.18613.16954.16954,0,0,1,.077.20981Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M77.8864,138.44458l-1.45256.0825a.676.676,0,0,1-.48851-.18l-.37293-.34463a.59085.59085,0,0,0,.09785.30932l1.05135,1.58064a.592.592,0,0,0,.51712.26366l.74829-.03066a.84206.84206,0,1,0-.10061-1.68081Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M79.8723,134.22665l-.36611.68314.46862.61942a.16951.16951,0,0,1-.02292.2293l-.05428.048a.09951.09951,0,0,0,.07143.17392l1.04213-.05787a.36607.36607,0,0,0,.31572-.22022l.37417-.8652a.09953.09953,0,0,0-.14251-.12487.16956.16956,0,0,1-.21987-.03993l-.61915-.77935-.697.21058A.25229.25229,0,0,0,79.8723,134.22665Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M79.89912,133.69532l.4861-.14685a.59091.59091,0,0,0-.31623-.07242l-1.89541.10529a.592.592,0,0,0-.48935.3122l-.35277.66063a.842.842,0,1,0,1.49994.76509l.665-1.294A.67607.67607,0,0,1,79.89912,133.69532Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M81.21535,138.41392l-.77662.01153a.16952.16952,0,0,1-.17134-.15407l-.00661-.07218a.09951.09951,0,0,0-.18247-.04527l-.56969.8746a.36607.36607,0,0,0-.00912.38481l.4764.81341a.09952.09952,0,0,0,.185-.04108.16951.16951,0,0,1,.16225-.15365l.99457-.03834.24241-.68657a.25239.25239,0,0,0-.01039-.194Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M83.11237,137.54575l-.32407-.67517a.84206.84206,0,1,0-1.504.75705l.65021,1.30154a.67594.67594,0,0,1,.0278.51987l-.16906.47881a.59086.59086,0,0,0,.24542-.21219L83.0747,138.125A.592.592,0,0,0,83.11237,137.54575Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M112.48118,142.90647a5.99288,5.99288,0,1,1,5.75168-6.22479A5.99969,5.99969,0,0,1,112.48118,142.90647Zm-.454-11.49445a5.51051,5.51051,0,1,0,5.72372,5.2887A5.51679,5.51679,0,0,0,112.02713,131.412Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M113.549,137.1601l1.98971-.0786-.53116-2.24935a.26271.26271,0,0,0-.26607-.20218l-3.67643.14523a.0823.0823,0,0,0-.02145.16075l2.22007.69857a.26277.26277,0,0,1,.18307.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M114.09381,134.3636a.71967.71967,0,1,0-.7475-.69071A.71967.71967,0,0,0,114.09381,134.3636Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M115.74279,140.534l-.198-3.29766-1.97715.0781-1.03532,3.40455a.08233.08233,0,0,0,.14284.07563l1.70822-2.11819,1.15112,1.92194A.1122.1122,0,0,0,115.74279,140.534Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M111.53489,140.86215l-1.50271.05936a.489.489,0,0,1-.49871-.40118l-.63877-3.58154a.487.487,0,0,1,.46026-.57222l2.49575-.09859a.4871.4871,0,0,1,.504.53408l-.35426,3.62086A.48909.48909,0,0,1,111.53489,140.86215Zm-2.16089-4.01359-.00446.00552.63877,3.58159.00483.00387,1.50271-.05936.00455-.00431.35426-3.62075-.00492-.00515Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M110.52779,140.902a.2412.2412,0,0,1-.24856-.21111l-.50965-4.07884a.24121.24121,0,0,1,.47869-.05981l.50961,4.07882a.24119.24119,0,0,1-.20943.26922Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M111.17952,140.87619c-.00553.00021-.01115.00025-.01681.00011a.24119.24119,0,0,1-.234-.24815l.12045-4.10373a.24118.24118,0,1,1,.48216.01414l-.12045,4.10375A.2412.2412,0,0,1,111.17952,140.87619Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M112.02655,138.01717l-2.709.107a.24117.24117,0,0,1-.019-.482l2.709-.107a.24117.24117,0,1,1,.019.482Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M111.99978,137.339l-2.709.107a.24117.24117,0,0,1-.019-.482l2.709-.107a.24117.24117,0,1,1,.019.482Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M111.92611,138.67817l-2.51194.09923a.24186.24186,0,0,1-.019-.482l2.51194-.09922a.24185.24185,0,0,1,.019.482Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M111.7499,139.54941l-2.1296.08412a.24117.24117,0,1,1-.019-.482l2.1296-.08412a.24117.24117,0,0,1,.019.482Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M110.02674,135.666l1.37514-.34036a.08418.08418,0,0,1,.08065.14032l-.63968.65952a.08418.08418,0,0,1-.107.01151Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmall);
export default __webpack_public_path__ + "static/media/Small.a06af1d2e13df50aa81b34ea62e3a01a.svg";
export { ForwardRef as ReactComponent };